import { all, call, put, takeLatest } from 'redux-saga/effects';
import notification from '../../services/notification';
import api from '../../services/api';
import types from '../types';

function* getProjects({ payload }) {
  try {
    console.log()
    const { status, data } = yield call(api.projects.getProjects, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_PROJECT_SUCCESS, payload: data.data });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}
function* getShowProject({ payload }) {
    try {
      const { data, status } = yield call(api.projects.getShowProject, payload);
      if (status < 200 || status >= 300) throw new Error('Something went wrong');
      yield put({ type: types.GET_PROJECT_SUCCESS, payload: data });
    } catch (error) {
      yield put({ type: types.GET_PROJECT_FAILURE });
      if (error?.response?.status === 401) return;
      notification({ type: 'error', message: 'Something went wrong' });
    }
  }
// function* deleteProject({ payload, pagination }) {
//   try {
//     const { status, data } = yield call(api.projects.deleteProject, payload);
//     if (status < 200 || status >= 300) throw new Error('Something went wrong');
//     yield put({ type: types.DELETE_PROJECT_SUCCESS, payload: data });
//     yield put({ type: types.GET_PROJECT_START, payload: pagination });
//     modal.close();
//   } catch (error) {
//     yield put({ type: types.DELETE_PROJECT_FAILURE });
//     if (error?.response?.status === 401) return;
//     notification({ type: 'error', message: 'Something went wrong' });
//   }
// }
export function* projects() {
    yield all([
      takeLatest(types.GET_PROJECT_START, getProjects),
      takeLatest(types.GET_PROJECT_ACCOUNT_START, getShowProject),
      // takeLatest(types.DELETE_PROJECT_START, deleteProject),

    ]);
}
  